import { useRecoilValue } from "recoil";
import { Input, Message, SelectPicker, Toggle } from "rsuite";
import { checkoutsAtom } from "../../../Atoms/checkouts.atom";

function AddEdit({ _setmodel, error, model }) {
  const checkouts = useRecoilValue(checkoutsAtom);
  return (
    <>
      <label>Nom:</label>
      <Input
        onChange={(name) => {
          _setmodel((prev) => {
            return { ...prev, name };
          });
        }}
        value={model.name}
      />
      <label>Solde Initial :</label>
      <Input
        type="number"
        step={0.1}
        onChange={(beginBalance) => {
          _setmodel((prev) => {
            return { ...prev, beginBalance: parseFloat(beginBalance) };
          });
        }}
        value={model.beginBalance}
      />
      <label>N°Compte (Sage) :</label>
      <Input
        type="number"
        step={1}
        onChange={(accountingNumber) => {
          _setmodel((prev) => {
            return { ...prev, accountingNumber: parseInt(accountingNumber) };
          });
        }}
        value={model.accountingNumber}
      />
      <label>Code Journal (Sage) :</label>
      <Input
        onChange={(code) => {
          _setmodel((prev) => {
            return { ...prev, code };
          });
        }}
        value={model.code}
      />
      <br></br>
      <label style={{ marginRight: "10px" }}> Dépense</label>
      <Toggle
        defaultChecked={model.isExpense}
        onChange={(isExpense) => {
          _setmodel((prev) => {
            return { ...prev, isExpense };
          });
        }}
        value={model.isExpense}
      />{" "}
      <i style={{ color: "#999" }}>( par default le type :Recette )</i>
      <br></br>
      {model.isExpense ? (
        <>
          <label>Liée à la caisse :</label>
          <SelectPicker
            data={checkouts
              .filter((ch) => !ch.isExpense)

              .map((c) => {
                return { label: c.name, value: c.id };
              })}
            block
            noSearch
            value={model.parentCheckoutId}
            onSelect={(parentCheckoutId) => {
              _setmodel((prev) => {
                return { ...prev, parentCheckoutId };
              });
            }}
          />
        </>
      ) : (
        ""
      )}
      <br></br>
      {error && (
        <Message showIcon type="error">
          {error}
        </Message>
      )}
    </>
  );
}

export default AddEdit;
